import { ShippingOptionRequest, ShippingOptionResponse } from "../../Models/Shipping";
import api from "../axios";

export const shippingService = {
  getOptions: async (data: ShippingOptionRequest): Promise<ShippingOptionResponse[] | null> => {
    const response = await api.post('/shipping/options', data);
    return response.data;
  }
};
